import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useSupportDiagnosticOptional } from './SupportModeContext';

export const DiagnosticFloatingWidget: React.FC = () => {
  const ctx = useSupportDiagnosticOptional();
  if (!ctx || ctx.phase !== 'recording') return null;

  return (
    <Box
      data-support-diagnostic-ui="1"
      className="support-diagnostic-floating"
      sx={{
        position: 'fixed',
        zIndex: (theme) => theme.zIndex.tooltip + 2,
        insetInlineEnd: { xs: 12, sm: 20 },
        bottom: { xs: 12, sm: 20 },
        maxWidth: 320,
        p: 2,
        borderRadius: 2,
        boxShadow: 6,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <span className="support-diagnostic-pulse" aria-hidden />
          <Typography variant="subtitle2" fontWeight={700} color="error.main">
            מקליט פעולות...
          </Typography>
        </Stack>
        <Typography variant="h4" component="p" sx={{ fontWeight: 800, textAlign: 'center' }}>
          {ctx.secondsLeft}
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="stretch">
          <Button fullWidth variant="contained" color="primary" size="small" onClick={ctx.submitNow}>
            שלח עכשיו
          </Button>
          <Button fullWidth variant="outlined" color="inherit" size="small" onClick={ctx.cancelRecording}>
            ביטול
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
